import RegistrationUser from './RegistrationUser';

export default RegistrationUser;
